import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const DashboardLayout = () => {
  const location = useLocation();

  const pm = Number(Cookies.get("Orbit_PMCount") || 0);
  const dev = Number(Cookies.get("Orbit_DevCount") || 0);
  const tester = Number(Cookies.get("Orbit_TesterCount") || 0);

  const routeAccess = {
    "/All-Tickets": ["pm"],
    "/New-Tickets": ["pm"],
    "/Unassigned-Tickets": ["pm"],
    "/Rejected-Tickets": ["pm"],

    "/Assigned-Tickets": ["pm", "dev"],
    "/In-Progess-Tickets": ["pm", "dev"],
    "/Ready-For-Review-Tickets": ["pm", "dev"],
    "/Reviewed-Tickets": ["pm", "dev", "tester"],
    "/Hold-Tickets": ["pm", "dev", "tester"],
    "/Closed-Tickets": ["pm", "dev", "tester"],

    "/Assign-To-Reviewer-Tickets": ["pm", "tester"],
    "/Review-In-Progress-Tickets": ["pm", "tester"],
    "/Reopen-Tickets": ["pm", "tester"],
  };

  if (pm > 0) {
    return layout();
  }

  const allowedRoles = routeAccess[location.pathname];

  if (!allowedRoles) {
    return layout();
  }

  const hasAccess =
    (allowedRoles.includes("dev") && dev > 0) ||
    allowedRoles.includes("tester") ||
    tester > 0;

  if (!hasAccess) {
    return <Navigate to="/home" replace />;
  }

  return layout();

  function layout() {
    return (
      <div className="flex h-screen bg-gray-50 relative">
        {/* Sidebar */}
        <Sidebar />

        {/* Main Section */}
        <div className="flex-1 flex flex-col">
          <Header />

          <main className="flex-1 overflow-y-auto px-6 pb-6">
            <Outlet />
          </main>

          <Footer />
        </div>
      </div>
    );
  }
};

export default DashboardLayout;
